module.exports = __webpack_public_path__ + "static/gunner-841f552ca4face948f56cea6003b3079.png";